import { render, staticRenderFns } from "./HorseRaceModal.vue?vue&type=template&id=063cb92d&scoped=true&"
import script from "./HorseRaceModal.vue?vue&type=script&lang=js&"
export * from "./HorseRaceModal.vue?vue&type=script&lang=js&"
import style0 from "./HorseRaceModal.vue?vue&type=style&index=0&id=063cb92d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063cb92d",
  null
  
)

export default component.exports